import * as yup from 'yup';
import { RendererType } from '../../../data-models/field-definition';
import { companyPeriodRequestFields } from '../../../schemas/CompanyPeriodRequest.schema';
import { companyFields } from '../../../schemas/Company.schema';
import { DateFormattersId } from '../../../util/formatters/DateFormatters';

export const V2RequestType = {
  universal: 'universal',
  firm: 'firm',
} as const;
export type V2RequestType = (typeof V2RequestType)[keyof typeof V2RequestType];

export function companyPeriodRequestViewModelFields() {
  const { fye } = companyFields();

  return {
    ...companyPeriodRequestFields(),
    companyName: yup.string().label('Company').required(),
    companyId: yup.number().gridMeta({ renderer: RendererType.companyId }).label('Company'),
    fye,
    /**
     * V2-only fields. Optional so V1 mapper output still satisfies the schema.
     * Always populated when produced by `mapV2CompanyPeriodRequestsToViewModel`,
     * always undefined when produced by the V1 mapper. Only consumed by the grid
     * when `mode === 'v2'`. Both fields become required in Stage 5 once V1 is removed.
     */
    requestType: yup.string().oneOf(Object.values(V2RequestType)),
    templateName: yup.string().nullable().label('Request Type'),
    // Date-only (YYYY-MM-DD); V2 mapper strips time via extractISODate. Null = not yet sent.
    sentAt: yup.string().nullable().label('Sent On').gridMeta({ formatter: DateFormattersId.date }),
    // Date-only (YYYY-MM-DD); V2 mapper strips time via extractISODate. Null = no due date.
    dueDate: yup.string().nullable().label('Due Date').gridMeta({ formatter: DateFormattersId.date }),
    // V2-only: the company's respondent emails, used to compose the reminder mailto.
    // Not shown as a column.
    recipients: yup.array().of(yup.string().required()).label('Recipients'),
    // V2-only email-delivery rollup; counts feed the indicator's tooltip only.
    emailStatus: yup.string().oneOf(['sent', 'partial', 'failed']).nullable().label('Email'),
    emailFailedCount: yup.number(),
    emailTotalCount: yup.number(),
  };
}

export function companyPeriodRequestViewModelSchema() {
  return yup.object(companyPeriodRequestViewModelFields());
}

export type CompanyPeriodRequestManageViewModel = yup.InferType<
  ReturnType<typeof companyPeriodRequestViewModelSchema>
>;
